import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { useTRPC } from "@/trpc/client";

export const useUpdateFolderStudySets = () => {
  const queryClient = useQueryClient();
  const trpc = useTRPC();

  return useMutation(
    trpc.folders.updateStudySets.mutationOptions({
      onSuccess: (_, { id: folderId }) => {
        queryClient.invalidateQueries({
          queryKey: trpc.folders.getUserFolders.queryKey(),
        });
        queryClient.invalidateQueries({
          queryKey: trpc.folders.getStudySets.queryKey({ id: folderId }),
        });
        queryClient.invalidateQueries({
          queryKey: trpc.studysets.getFolders.queryKey(),
        });
        toast.success("Study sets updated");
      },
      onError: (error) => {
        console.error("Failed to update folder study sets", error);
        toast.error(error.message);
      },
    }),
  );
};
